<template>
  <main class="ws">

<!-- ============ 首屏 ============ -->
<section class="ph ph--ink ph--center">
  <div class="wrap">
    <span class="ph__kicker">{{ $t("收款与结算") }}</span>
    <h1 class="ph__title">{{ $t("客户怎么付得方便，") }}<br class="br-m">{{ $t("你就怎么收") }}</h1>
    <p class="ph__sub">{{ $t("欧美人习惯刷卡、德国人爱用 PayPal、东南亚用本地钱包、中东还在转账——") }}<b>{{ $t("多种收单方式接上就能用") }}</b>{{ $t("，后台统一看账。") }}</p>
    <div class="btns" style="justify-content:center">
      <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店，绑定收款") }}</router-link>
      <a class="btn btn--line" href="#fees">{{ $t("看费率") }}</a>
    </div>
    <p class="ph__meta">
      <i><svg class="ico"><use href="#i-check"/></svg>{{ $t("不用自己申请商户号") }}</i>
      <i><svg class="ico"><use href="#i-clock"/></svg>{{ $t("T+7 自动结算") }}</i>
      <i><svg class="ico"><use href="#i-refresh"/></svg>{{ $t("多币种提现") }}</i>
    </p>


  </div>
</section>

<div class="guide-band guide-band--after-ink">
  <div class="wrap">
<div class="guide guide--center">
      <img class="guide__m" src="/website/img/tao-hi.png" alt="">
      <div class="bubble">{{ $t("最常被问的是「钱什么时候到我账上」。") }}<b>{{ $t("答案写在结算规则里") }}</b>{{ $t("，不用发邮件问。") }}</div>
    </div>
  </div>
</div>

<!-- ============ 数据 ============ -->
<section class="sec sec--tight">
  <div class="wrap">
    <div class="metrics">
      <div class="metric"><b>8</b><span>{{ $t("种收单方式可选") }}</span></div>
      <div class="metric"><b>T+7</b><span>{{ $t("妥投后 7 天可提现") }}</span></div>
      <div class="metric"><b>6</b><span>{{ $t("支持提现的币种") }}</span></div>
      <div class="metric"><b>3–6<em>%</em></b><span>{{ $t("交易佣金阶梯") }}</span></div>
    </div>
    <p class="plans__note">{{ $t("T+7 是留出的退款与拒付窗口。已妥投且过了窗口的订单，余额可随时提现。") }}</p>
  </div>
</section>

<!-- ============ 收单方式 ============ -->
<section class="sec sec--gray" id="methods">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("收单") }}</span>
      <h2 class="sec__title">{{ $t("客户看到的付款方式，越多越容易成交") }}</h2>
      <p class="sec__sub">{{ $t("结账页上少一个支付选项，就可能少一单。常用的这几种，默认都开着。") }}</p>
    </div>

    <div class="grid3">
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-wallet"/></svg></span>
        <h3 class="card__t">PayPal</h3>
        <p class="card__d">{{ $t("欧美客户最认的一种，有买家保护，争议处理流程成熟。") }}</p>
        <ul class="card__list"><li>{{ $t("覆盖 200+ 国家") }}</li><li>{{ $t("支持信用卡无账号付款") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-card"/></svg></span>
        <h3 class="card__t">{{ $t("信用卡 / 借记卡") }}</h3>
        <p class="card__d">{{ $t("通过 Stripe 收 Visa、Mastercard、Amex，3D 验证默认开启。") }}</p>
        <ul class="card__list"><li>{{ $t("支持自动扣款与订阅") }}</li><li>{{ $t("拒付率低于纯 PayPal 通道") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-bank"/></svg></span>
        <h3 class="card__t">{{ $t("本地钱包") }}</h3>
        <p class="card__d">{{ $t("德国的 Klarna、荷兰的 iDEAL、巴西的 Pix，按市场自动出现。") }}</p>
        <ul class="card__list"><li>{{ $t("按客户所在地展示") }}</li><li>{{ $t("不用单独签约") }}</li></ul>
      </article>
    </div>

    <div class="note" style="margin-top:24px;max-width:820px">
      <svg class="ico"><use href="#i-lock"/></svg>
      <span><b>{{ $t("收款账户是你自己的") }}</b>{{ $t("。平台不代收货款，钱从客户直接进你的 PayPal / Stripe 账户，我们不碰这笔钱。") }}</span>
    </div>
  </div>
</section>

<!-- ============ 资金流向 ============ -->
<section class="sec">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("资金流向") }}</span>
      <h2 class="sec__title">{{ $t("一笔钱从客户到你的账上，走四步") }}</h2>
    </div>

    <div class="flow">
      <div class="flow__node">
        <div class="flow__icon"><svg class="ico"><use href="#i-card"/></svg></div>
        <em>{{ $t("客户付款") }}</em>
        <p>{{ $t("结账页选方式") }}<br>{{ $t("按当地币种支付") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node">
        <div class="flow__icon"><svg class="ico"><use href="#i-shield"/></svg></div>
        <em>{{ $t("进入你的账户") }}</em>
        <p>PayPal / Stripe<br>{{ $t("不经过平台") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-clock"/></svg></div>
        <em>{{ $t("订单妥投") }}</em>
        <p>{{ $t("轨迹显示签收") }}<br>{{ $t("开始算 T+7") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-refresh"/></svg></div>
        <em>{{ $t("提现到账") }}</em>
        <p>{{ $t("提人民币或外币") }}<br>{{ $t("1–3 个工作日") }}</p>
      </div>
    </div>
  </div>
</section>

<!-- ============ 费率 ============ -->
<section class="sec sec--gray" id="fees">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("费率") }}</span>
      <h2 class="sec__title">{{ $t("每一笔扣多少，写在明面上") }}</h2>
      <p class="sec__sub">{{ $t("通道费由收单机构收，平台不在这上面加价。") }}</p>
    </div>

    <div class="tbl-wrap">
      <table class="tbl">
        <thead>
          <tr><th>{{ $t("收单方式") }}</th><th>{{ $t("参考费率") }}</th><th>{{ $t("到账时间") }}</th><th>{{ $t("提现费") }}</th><th>{{ $t("争议处理") }}</th></tr>
        </thead>
        <tbody>
          <tr><td>PayPal</td><td class="num">{{ $t("约 4.4% + $0.30") }}</td><td>{{ $t("即时到 PayPal 余额") }}</td><td class="num">{{ $t("按提现通道") }}</td><td>{{ $t("买家保护，180 天") }}</td></tr>
          <tr><td>{{ $t("信用卡（Stripe）") }}</td><td class="num">{{ $t("约 2.9% + $0.30") }}</td><td>{{ $t("T+2 到 Stripe 余额") }}</td><td class="num">{{ $t("按提现通道") }}</td><td>{{ $t("拒付 15–30 天内申诉") }}</td></tr>
          <tr><td>{{ $t("支付宝 / Alipay+") }}</td><td class="num">{{ $t("约 1.2%") }}</td><td>T+1</td><td class="num">{{ $t("免") }}</td><td>{{ $t("平台介入") }}</td></tr>
          <tr><td>{{ $t("本地钱包") }}</td><td class="num">{{ $t("约 1.5%–2.5%") }}</td><td>T+2</td><td class="num">{{ $t("免") }}</td><td>{{ $t("按当地规则") }}</td></tr>
          <tr><td>{{ $t("Taoify 平台服务费") }}</td><td class="num">0</td><td>—</td><td class="num">—</td><td>—</td></tr>
        </tbody>
      </table>
    </div>
    <p class="cmp__note">{{ $t("费率为行业常见区间，实际以你与收单机构签约时的条款为准；不同国家、不同卡种会有差异。") }}</p>
  </div>
</section>

<!-- ============ 风控 ============ -->
<section class="sec">
  <div class="wrap">
    <div class="frow">
      <div>
        <span class="frow__tag">{{ $t("风控") }}</span>
        <h2 class="frow__t">{{ $t("最怕的不是没单，是收了钱又被退回去") }}</h2>
        <p class="frow__d">{{ $t("高风险订单在付款时就会被拦下来——地址和卡不一致、短时间多笔、代理 IP。与其事后申诉，不如事前不接。") }}</p>
        <ul class="frow__list">
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("高风险订单自动标记，可选择暂缓发货") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("每笔拒付的申诉材料模板，照着填就行") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("拒付率接近警戒线时提前提醒，避免被封号") }}</span></li>
        </ul>
      </div>
      <div class="frow__media">
        <div class="media-card">
          <div class="tbl-wrap" style="border-radius:12px">
            <table class="tbl" style="min-width:0">
              <thead><tr><th>{{ $t("订单") }}</th><th>{{ $t("金额") }}</th><th>{{ $t("风险") }}</th><th>{{ $t("建议") }}</th></tr></thead>
              <tbody>
                <tr><td>#TF-2841</td><td class="num">$76.00</td><td><span style="color:#2FA96B">{{ $t("低") }}</span></td><td>{{ $t("正常发货") }}</td></tr>
                <tr><td>#TF-2842</td><td class="num">$128.50</td><td><span style="color:#B7822C">{{ $t("中") }}</span></td><td>{{ $t("核对地址") }}</td></tr>
                <tr><td>#TF-2843</td><td class="num">$9.90</td><td><span style="color:#2FA96B">{{ $t("低") }}</span></td><td>{{ $t("正常发货") }}</td></tr>
                <tr><td>#TF-2844</td><td class="num">$420.00</td><td><span style="color:#D14343">{{ $t("高") }}</span></td><td>{{ $t("暂缓 · 卡地不符") }}</td></tr>
              </tbody>
            </table>
          </div>
          <div class="note" style="margin-top:14px">
            <svg class="ico"><use href="#i-shield"/></svg>
            <span>{{ $t("高风险订单不会自动取消，") }}<b>{{ $t("决定权还在你") }}</b>{{ $t("，系统只负责提醒。") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 提现 ============ -->
<section class="sec sec--gray">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("提现") }}</span>
      <h2 class="sec__title">{{ $t("赚的钱，随时能拿出来") }}</h2>
    </div>
    <div class="grid3">
      <article class="card">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-bank"/></svg></span>
        <h3 class="card__t">{{ $t("提到银行卡") }}</h3>
        <p class="card__d">{{ $t("人民币直接进国内储蓄卡，1–3 个工作日到账，单笔最低 100 元。") }}</p>
      </article>
      <article class="card">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-globe"/></svg></span>
        <h3 class="card__t">{{ $t("留在外币账户") }}</h3>
        <p class="card__d">{{ $t("美元、欧元、英镑可以留着付广告费、付供应商，不用来回换汇。") }}</p>
      </article>
      <article class="card">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-doc"/></svg></span>
        <h3 class="card__t">{{ $t("对账单") }}</h3>
        <p class="card__d">{{ $t("每笔收入、退款、拒付都有流水，按月导出，报税和记账直接用。") }}</p>
      </article>
    </div>
  </div>
</section>

<!-- ============ CTA ============ -->

<section class="sec sec--tight">
  <div class="wrap">
    <div class="pandy">
      <img class="pandy__m" src="/website/img/tao-hi.png" alt="">
      <div>
        <p class="pandy__t">{{ $t("费率这块最容易看漏一句") }}</p>
        <p class="pandy__b"><b>{{ $t("收款账户是你自己的") }}</b>{{ $t("。钱从客户那里直接进你的账户，平台不代收，也就不存在压款、跑路、限额提不出来这些事。") }}</p>

      </div>
    </div>
  </div>
</section>

<section class="sec sec--tight">
  <div class="wrap">
    <div class="cta">
      <div>
        <h2 class="cta__t">{{ $t("先把收款接上，再谈卖什么") }}</h2>
        <p class="cta__d">{{ $t("开店后绑定 PayPal 或 Stripe，当天就能收第一笔钱。") }}</p>
      </div>
      <div class="cta__btns">
        <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店") }}</router-link>
        <router-link class="btn btn--ghost" to="/pricing">{{ $t("看价格") }}</router-link>
      </div>
    </div>
  </div>
</section>

</main>
</template>

<script>
export default {
  name: 'WebsitePayments',
}
</script>
